import { Seo } from "@/lib/seo";
import { NotFound } from "@/components/States";

// Full 404 view: emits noindex,follow + unique title/description (no homepage schema/canonical)
// and renders the recovery UI. Used by the catch-all route and by detail pages on not-found.
export function NotFoundView() {
  return (
    <>
      <Seo
        title="Page not found | Hotelstrips"
        description="The page you're looking for doesn't exist or the event may have already taken place. Explore GameDay, venues and guides on Hotelstrips."
        noindex
        path="/404"
      />
      <NotFound />
    </>
  );
}
